import { BeaconType } from 'core/advertiser/BeaconConnection';
import { useMemo } from 'react';
import { FormConfig } from 'components/common/form/FormConfig';
import { renderOutdoorLineMessageFields } from './OutdoorLineMessageFields';
import i18n from 'i18n';
import { createSelectOptionsFromEnum } from 'utils/SelectOptionsUtils';
import { LineUserLanguage } from 'core/advertiser/LineBeacon';
import { toLower } from 'lodash';
import { validateEmpty } from 'utils/ValidateUtils';

export const useLineMessageFields = (
  beaconType: BeaconType,
  advertiserId: number | null | undefined,
  showLanguageOptions = true,
  fieldPath = ''
) => {
  const languageOptions = useMemo(
    () =>
      createSelectOptionsFromEnum(
        LineUserLanguage,
        'beaconFields.labels.lineUserLanguage.',
        [],
        toLower
      ),
    []
  );

  const fields = useMemo(() => {
    if (beaconType !== BeaconType.LINE_SIMPLE_BEACON) {
      return [];
    }

    const fieldsBuilder = new FormConfig.FieldsBuilder();
    if (showLanguageOptions) {
      fieldsBuilder.addFormikSelect({
        label: i18n.t('beaconFields.labels.language'),
        name: `${fieldPath}typeProperties.language`,
        simpleValue: true,
        options: languageOptions,
        validate: validateEmpty
      });
    }

    return fieldsBuilder
      .addFormikCustom({
        withFieldLayout: false,
        name: 'lineMessageContainer',
        render: () => renderOutdoorLineMessageFields(advertiserId, fieldPath)
      })
      .build();
  }, [
    showLanguageOptions,
    beaconType,
    languageOptions,
    advertiserId,
    fieldPath
  ]);

  return fields;
};
